import Skeleton from '@mui/material/Skeleton';
import type { FunctionComponent } from 'react';

import { SkillMosaicWrapper } from './components/SkillMosaicWrapper';

export const SkillMosaicSkeleton: FunctionComponent = () => {
    return (
        <SkillMosaicWrapper>
            <Skeleton animation="wave" height="100%" variant="rounded" />
        </SkillMosaicWrapper>
    );
};
